import React, { useEffect, useState, useRef } from 'react'
import { Link, useParams, useHistory } from 'react-router-dom'
import {
  IonContent,
  IonGrid,
  IonRow,
  IonButton,
  IonIcon,
  useIonViewDidEnter,
  useIonViewWillLeave
} from '@ionic/react'
import {
  chevronForwardOutline,
  chevronBackOutline
} from 'ionicons/icons'
import EditorCard from './components/EditorCard'
import EditorCardSkeleton from './components/EditorCardSkeleton'
import { setRootMetaTags } from '../../services/metatags'
import { setView } from '../../services/analytics'
import { setPixelView } from '../../services/fbPixel'
import { NewsRadioCard } from '../../components/common/NewsRadioCard'
import { Advertisement } from '../../components/common/Advertisement'
import { NewsRadioCardSkeleton } from '../../components/skeletons/NewsRadioCardSkeleton'
import AdvertisementSkeleton from '../../components/skeletons/AdvertisementSkeleton'
import { getContentFeed } from '../../services/api/contents'
import { getEditor } from '../../services/api/editor'
import { newsSettings } from '../../config/pages'
import './styles.scss'

const Editor = (props) => {
  const [isVisible, setIsVisible] = useState(false)
  const [contents, setContents] = useState(false)
  const [xhr, setXhr] = useState('pending')
  const [editor, setEditor] = useState(false)
  const contentRef = useRef()
  const { hashid, page } = useParams()
  const [id, name] = hashid.split('_')
  const history = useHistory()

  useIonViewDidEnter(() => {
    setIsVisible(true)
    setRootMetaTags()
  })

  useIonViewWillLeave(() => {
    setIsVisible(false)
  })

  useEffect(() => {
    const params = {
      id: id,
      name: name
    }
    getEditor(params)
      .then((response) => {
        setEditor(response)
        setView(window.location.pathname)
        setPixelView()
      }).catch(() => {
        setEditor(false)
        history.push('/404')
      })
    return () => {
      setEditor(false)
    }
  }, [hashid])

  useEffect(() => {
    const params = {
      limit: 12,
      category_id: [3, 6, 20],
      section: 'news',
      editor_id: id,
      offset: parseInt(page) - 1
    }
    getContentFeed(params)
      .then((response) => {
        setContents(response)
        setXhr('accepted')
      }).catch(() => {
        setContents([])
        setXhr('rejected')
      })
    return () => {
      setContents([])
    }
  }, [hashid, page])

  if (isVisible === false) return null

  return (
    <IonContent
      ref={contentRef}
      fullscreen
      className='editor-page page-wrapper'
    >
      {xhr === 'pending' &&
        <EditorCardSkeleton />}

      {editor !== false &&
        <EditorCard editor={editor} />}

      {contents === false &&
        <IonGrid>
          <IonRow>
            <AdvertisementSkeleton />
          </IonRow>
          <IonRow>
            <NewsRadioCardSkeleton />
            <NewsRadioCardSkeleton />
            <NewsRadioCardSkeleton />
            <NewsRadioCardSkeleton />
            <NewsRadioCardSkeleton />
            <NewsRadioCardSkeleton />
            <NewsRadioCardSkeleton />
            <NewsRadioCardSkeleton />
            <NewsRadioCardSkeleton />
          </IonRow>
        </IonGrid>}

      {xhr === 'accepted' &&
        <>
          <section>
            <Advertisement />
          </section>

          <section className='feed-wrapper'>
            <IonGrid>
              <IonRow>
                {contents.map(content =>
                  <NewsRadioCard
                    key={content.id}
                    content={content}
                  />
                )}
              </IonRow>
            </IonGrid>
          </section>

          <section className='buttons-wrapper'>
            {page > 1 &&
              <Link to={`/editor/${hashid}/${parseInt(page) - 1}`}>
                <IonButton className='previous'>
                  <IonIcon icon={chevronBackOutline} />
                </IonButton>
              </Link>}

            {newsSettings.navigation.rows === contents.length &&
              <Link to={`/editor/${hashid}/${parseInt(page) + 1}`}>
                <IonButton className='next'>
                  <IonIcon icon={chevronForwardOutline} />
                </IonButton>
              </Link>}
          </section>

          <section>
            <Advertisement />
          </section>
        </>}

      {xhr === 'rejected' &&
        <section className='no-content'>
          <h1>
            Parece que eso es todo por ahora
            <span role='img' aria-label='emoji sonrisa de pena'> &#128556;</span>
          </h1>
          <p>Todo indica que {editor ? editor.first_name : 'este editor'} aún no hecho su primer artículo, puedes volver luego para ver todo el asombroso contenido que está preparando para vos. </p>
        </section>}
    </IonContent>
  )
}

export default Editor
